import Vue from 'vue';
import store from './store';
import { getDiceDetails, getPollDetails, getSurveyDetails } from './utils/firebase-methods';

// Dice component
import Dice from './Dice.vue';
import Poll from './Poll.vue';
import Survey from './Survey.vue';

// Production tip
Vue.config.productionTip = process.env.NODE_ENV === 'production';

// Loop all items with sa-reviews class
const items = document.querySelectorAll('.sa-reviews');
if (items) {
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (item.hasAttribute('data-item') && item.hasAttribute('data-items')) {
      const items_id = item.getAttribute('data-items');
      const item_id = item.getAttribute('data-item');
      // start fetch of dice details
      getDiceDetails(items_id, item_id);
      // New vue app
      new Vue({
        store,
        data() {
          return {
            items: items_id,
            item: item_id,
          };
        },
        render: h => h(Dice),
      }).$mount(item);
    }
  }
}

// Loop all items with sa-poll class
const polls = document.querySelectorAll('.sa-poll');
if (polls) {
  for (let i = 0; i < polls.length; i++) {
    const poll = polls[i];
    if (poll.hasAttribute('data-poll')) {
      const poll_id = poll.getAttribute('data-poll');
      // start fetch of dice details
      getPollDetails(poll_id);
      // New vue app
      new Vue({
        store,
        data() {
          return {
            poll: poll_id,
          };
        },
        render: h => h(Poll),
      }).$mount(poll);
    }
  }
}

// Loop all items with sa-poll class
const surveys = document.querySelectorAll('.sa-survey');
if (surveys) {
  for (let i = 0; i < surveys.length; i++) {
    const survey = surveys[i];
    if (survey.hasAttribute('data-survey')) {
      const survey_id = survey.getAttribute('data-survey');
      // start fetch of dice details
      getSurveyDetails(survey_id);
      // New vue app
      new Vue({
        store,
        data() {
          return {
            survey: survey_id,
          };
        },
        render: h => h(Survey),
      }).$mount(survey);
    }
  }
}